import { Component, Input } from '@angular/core';
import { SelectedPremiumInfo, SubscriptionFormViewModel } from '~app/farp-odq/store/subscription/subscription.model';


@Component({
    selector: 'odq-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss', '../styles/subscription-forms.css'],
    standalone: false
})
export class SummaryComponent {

  @Input() model: SubscriptionFormViewModel;
  @Input() loading: boolean;
  @Input() selectedPremium: SelectedPremiumInfo;
  @Input() inactiveMemberForSubscription: boolean;
}